module.exports = __webpack_public_path__ + "img/blog-02.9df07c39.jpg";